export default __webpack_public_path__ + "static/media/second_section_a.dfcd2291.png";